// Resolve a server-relative path against the document's base URI.
//
// In Electron (file://) and root-domain web deploys this returns the same
// absolute path you'd get with a leading slash. In sub-path deploys (e.g.
// the SPA is served at https://host/agentic-gis/), it transparently prefixes
// the sub-path so a call to apiPath('/api/health') hits
// /agentic-gis/api/health on the same origin.
//
// Centralising this here means the rest of the app can keep using the
// canonical "/api/..." paths without having to know about deployment shape.

function baseHref(): string {
  // Vite bakes BASE_URL at build time:
  //   - default "./":              relative — fall back to document.baseURI
  //   - "/":                       web root deploy
  //   - "/agentic-gis/":           web sub-path deploy
  const baked = (import.meta.env?.BASE_URL ?? '').trim();
  if (baked && baked !== './' && baked !== '.') {
    return baked.endsWith('/') ? baked : baked + '/';
  }
  if (typeof document === 'undefined') return '/';
  try {
    const u = new URL(document.baseURI);
    const path = u.pathname.endsWith('/')
      ? u.pathname
      : u.pathname.replace(/[^/]*$/, '');
    return path || '/';
  } catch {
    return '/';
  }
}

export function apiPath(path: string): string {
  const rel = path.replace(/^\/+/, '');
  const base = baseHref();
  return base + rel;
}

export function wsUrl(path: string): string {
  const proto = location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${location.host}${apiPath(path)}`;
}

export function originWithBase(): string {
  // Useful as a "where am I served from" prefix for absolute URLs (e.g. the
  // ArcGIS portal proxy rewrite). Includes scheme+host+sub-path, no trailing
  // slash.
  return location.origin + baseHref().replace(/\/$/, '');
}
